import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ComponentType, ReactElement } from 'react';

interface IProps {
  name: string;
  icon: ComponentType<{ className?: string }>;
  link: string;
  isExpanded: boolean;
  id?: string;
}

export const SideNavigationExternalItem = observer((props: IProps): ReactElement => {
  const Icon = props.icon;

  return (
    <div
      id={props.id}
      className={classNames('side-navigation-item', { expanded: props.isExpanded })}
    >
      <a
        target='_blank'
        href={props.link}
        rel='noopener noreferrer'
        className='side-navigation-link side-navigation-link-external'
      >
        <Icon className='side-navigation-icon' />
        {props.isExpanded && <div className='side-navigation-label'>{props.name}</div>}
      </a>
    </div>
  );
});
